<template>
  <div style="text-align: center;">
    <p style="margin-top: 15px;" v-html="message"></p>
    <div style="text-align: center;">
      <button type="button" style="margin-right: 10px;" class="btn btn-fill btn-info inline-block" @click="closeModal">Add Email(s)</button>
      <p-button wide class="inline-block" @click.native="skipAddContactEmail">Skip</p-button>
    </div>
  </div>
</template>

<script>
  export default {
    props: ['data'],
    computed: {
      message() {
        const builderContact = this.data.builderContact
        const clientContact = this.data.clientContact

        if (builderContact && clientContact) {
          return `Client Contact <strong>${clientContact.name}</strong> and Builder Contact <strong>${builderContact.name}</strong> have no email addresses configured. Would you like to add them?`;
        } else if (builderContact) {
          return `Builder Contact <strong>${builderContact.name}</strong> has no email address configured. Would you like to add one?`;
        } else {
          return `Client Contact <strong>${clientContact.name}</strong> has no email address configured. Would you like to add one?`;
        }
      }
    },
    methods: {
      skipAddContactEmail() {
        this.$eventHub.$emit('doNotAddContactEmail')
        this.closeModal()
      },
      closeModal() {
        this.$emit('close')
      }
    }
  }
</script>
